"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    img: 'https://placehold.it/300x375',
    alt: '',
    heading: 'Subscribe to our newsletter',
    content: 'Sign up here to get the latest news, updates and special offers delivered directly to your inbox.',
    collapsed: false,
    exportedHTML: ''
  };
}